import React from 'react';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';
import { ExecuteToggle } from 'state/ducks/Modals';
import { Utils } from 'utils/Utils';
import { Link } from 'react-router-dom';
import Sobre from 'assets/data/glampartnerRegrasCampanhas';

import { Modal } from 'components/modal/Modal';

import { Tooltip } from 'components/elements/Tooltip';
import { Info } from 'components/icons/Info';

import { FileHandler2 } from 'views/development/FileHandler2';
import { Delete } from 'components/elements/file/Delete';

import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';
import { SecondPinkButton } from 'components/buttons/SecondPinkButton';

import PaginatorStyles from 'components/general/Paginator.module.scss';
import Styles from './styles.module.scss';
import unloadImage from 'assets/svg/unload-image.svg';

import { FiChevronUp, FiChevronDown } from 'react-icons/fi';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';

export class ParticiparCampanhasMarcas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      pageSize: 9,
      campaigns: [],
      receipts: [],
      totalOfItems: 0,
      totalOfPages: 0,

      currentCampaignId: null,
      currentCampaignTitle: null,
      currentCampaign: null,
      campaignProducts: null,

      campaignInfoVisible: false,

      aboutList: [],
    };

    this.sectionAboutRef = React.createRef();
  }

  componentDidMount() {
    const aboutList = Sobre.map(sobre => {
      return {
        ...sobre,
        isOpened: false,
      };
    });

    this.setState({
      aboutList: [...aboutList],
    });

    this.getMyCampaigns();
  }

  getMyCampaigns = async () => {
    const { currentPage, pageSize } = this.state;
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getCampaigns,
      {
        page: currentPage - 1,
        pageSize,
      },
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { statusCode, result } = response;

        console.log(result.campaigns);

        if (statusCode === 200) {
          this.setState({
            campaigns: result.campaigns.map(campaign => {
              return {
                ...campaign,
                isOpened: false,
              };
            }),
            totalOfItems: result.totalOfItems,
            totalOfPages: result.totalOfPages,
          });
        }
        this.props.loaderHide();
      }
    );
  };

  getCampaignProducts = async () => {
    const { currentCampaign } = this.state;
    const campaignId = currentCampaign.campaignId;

    await ExecuteRequest(
      GlamboxEndpoints.Campaign.getCampaignsProducts,
      null,
      'GET',
      { Authorization: this.props.token },
      {
        campaignId,
      },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            campaignProducts: result.campaignProducts,
          });
        }
      }
    );
  };

  getCampaignReceipts = async () => {
    const { currentCampaign } = this.state;

    if (!currentCampaign) return null;
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getCampaignReceipts,
      {
        campaignId: currentCampaign.campaignId,
      },
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            receipts: result.receipts,
          });
        }
      }
    );
  };

  switchCampaignActionStatus = campaign => {
    let _color = '';
    let _status = campaign.campaignMemberStatus;
    let _refusedStatus = false;

    switch (campaign.campaignMemberStatus) {
      case 'Participando':
        _color = '#77d16b';
        break;
      case 'Em análise':
        _color = '#ebde59';
        break;
      case 'Concluído':
        _color = '#747f8b';
        break;
      case 'Recusada':
        _color = '#747f8b';
        _status = campaign.campaignMemberStatus.replace(
          'Recusada',
          'Desculpe, não foi dessa vez :('
        );
        _refusedStatus = true;
        break;
      default:
        _color = '#747f8b';
        break;
    }
    return {
      _color,
      _status,
      _refusedStatus,
    };
  };

  toggleShowAndHideAbout = index => {
    const currentAboutList = this.state.aboutList;

    currentAboutList[index].isOpened = !currentAboutList[index].isOpened;

    this.setState({
      aboutList: [...currentAboutList],
    });
  };

  toggleShowAndHideCampaign = index => {
    const currentCampaigns = this.state.campaigns;

    currentCampaigns[index].isOpened = !currentCampaigns[index].isOpened;

    this.setState({
      campaigns: [...currentCampaigns],
    });
  };

  handleScrollIntoView(ref) {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  subscribe = campaign => {
    ExecuteRequest(
      GlamboxEndpoints.Partner.subscribeCampaign,
      {
        campaignId: campaign.campaignId,
      },
      'POST',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.props.publishSuccessAlert(
            'Inscrição realizada com sucesso. Aguarde aprovação'
          );
        } else {
          this.props.publishErrorAlert(result.message);
        }
      }
    );
  };

  renderUploadReceipts = () => {
    const { currentCampaign } = this.state;
    const url = GlamboxEndpoints.Partner.uploadCampaignReceipts.url;
    return (
      <div>
        <FileHandler2
          token={this.props.token}
          uploadUrl={`${process.env.REACT_APP_GB_API_ROOT}${url}/${currentCampaign.campaignId}`}
          finish={this.finish}
          acceptFilesType={['image/png', 'image/jpg', 'image/jpeg']}
          multiple={true}
        />
        {this.renderFiles()}
      </div>
    );
  };

  finish = filesUploaded => {
    if (filesUploaded.length > 0) {
      this.setState({
        receipts: [...this.state.receipts, ...filesUploaded],
      });
    }
  };

  onDeleteFinish = fileDeleted => {
    const { receipts } = this.state;

    let receiptsUpdated = receipts.filter(receipt => {
      return receipt != fileDeleted;
    });

    this.setState({
      receipts: receiptsUpdated,
    });
  };

  renderFiles = () => {
    const { receipts, currentCampaign } = this.state;
    if (receipts.length < 1) return null;
    let renderReceipts = receipts.map((receipt, key) => {
      return (
        <div key={key}>
          <figure>
            <img src={receipt.imageUrl} />
          </figure>

          <Delete
            files={[receipt]}
            deleteUrl={GlamboxEndpoints.Partner.deleteCampaignReceipt}
            fields={{ campaignId: currentCampaign.campaignId }}
            headers={{
              Authorization: this.props.token,
            }}
            onDeleteFinish={this.onDeleteFinish}
          />
        </div>
      );
    });

    return <div className={Styles['files']}>{renderReceipts}</div>;
  };

  renderCampaignInfo = () => {
    const { currentCampaign } = this.state;
    if (!currentCampaign) return null;
    let isCampaignMember =
      currentCampaign.campaignMemberStatus === 'Participando';

    return (
      <div className="container">
        <div className={'row justify-content-between'}>
          <div className={'col'}>
            <div className={Styles['more-details']}>
              <h3> {currentCampaign.title} </h3>
              <ul>
                <li>
                  <small>
                    De {Utils.tempConvertDate(currentCampaign.dateFrom)} até{' '}
                    {Utils.tempConvertDate(currentCampaign.dateTo)}
                  </small>
                </li>
                <li>
                  {currentCampaign.urlFile ? (
                    <>
                      <a
                        href={currentCampaign.urlFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Briefing
                      </a>
                      <br />
                    </>
                  ) : null}
                </li>
                <li>
                  {' '}
                  <strong>
                    Remuneração:
                  </strong> {`R$${currentCampaign.payment}`}{' '}
                </li>
              </ul>
              <p>
                <strong>Descrição:</strong> {currentCampaign.description}{' '}
              </p>
              <div>{currentCampaign.product}</div>
            </div>
          </div>

          {isCampaignMember ? (
            <div className={'col-md-6 text-center'}>
              <div className={Styles['more-details-upload']}>
                <h3> Envio de Comprovante </h3>
                <p>
                  {' '}
                  Faça o upload do comprovante de divulgação da campanha nas
                  usas redes sociais{' '}
                </p>
                <p>
                  {' '}
                  <small>Requisitos da imagem</small>
                  <Tooltip position={'top'} label={'Formato jpg ou png'}>
                    <Info
                      className="_infoButton"
                      fill={'#747F8B'}
                      size={'16px'}
                    />
                  </Tooltip>
                </p>
                <div className={Styles['campaign-receipt-container']}>
                  {this.renderUploadReceipts()}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  // Toggles
  // ------------------------ ------------------------------------------------------
  toggleSubscriptionModal = campaign => {
    return e => {
      if (e !== undefined) {
        e.stopPropagation();
        e.preventDefault();
      }

      if (campaign) {
        this.setState({
          currentCampaign: campaign,
          currentCampaignId: campaign.campaignId,
          currentCampaignTitle: `${campaign.title} ${campaign.project}`,
          subscriptionModalVisible: !this.state.subscriptionModalVisible,
        });
      }
    };
  };

  toggleCampaignInfo = campaign => {
    console.log(campaign);

    this.setState({ campaignInfoVisible: !this.state.campaignInfoVisible });

    if (campaign) {
      this.setState({ currentCampaign: campaign }, () => {
        this.getCampaignReceipts();
        this.getCampaignProducts();
      });
    }
  };

  _renderCampaignCard = (campaign, index) => {
    let sendVoucherCampaign = false;

    const { _color, _status, _refusedStatus } =
      this.switchCampaignActionStatus(campaign);

    if (_status === 'Participando') {
      sendVoucherCampaign = true;
    }

    return (
      <div key={campaign.campaignId} className={Styles['campaign-card']}>
        <div className={Styles['card-header']}>
          <img src={campaign.urlImg || unloadImage} alt={campaign.title} />
        </div>
        <div className={Styles['card-body']}>
          <span>
            {campaign.title} {campaign.project}
          </span>
          <span>
            De {Utils.tempConvertDate(campaign.dateFrom)} &nbsp; até{' '}
            {Utils.tempConvertDate(campaign.dateTo)}
          </span>
          <div>
            <span>Remuneração:</span>
            <strong className={Styles['price']}>
              {Utils.toCurrency(campaign.payment)}
            </strong>
          </div>

          <div className={Styles['status-content']}>
            <span>Status</span>

            <strong
              style={{
                color: _color,
              }}
            >
              {_status}
            </strong>
          </div>
        </div>

        <div className={Styles['card-footer']}>
          {campaign?.isOpened && (
            <div className={Styles['campaign-description']}>
              <strong>Descrição:</strong>
              <p>{campaign.description}</p>
            </div>
          )}
          <PrimaryPinkButton
            onClick={() => this.toggleShowAndHideCampaign(index)}
          >
            Saiba mais
            {campaign?.isOpened ? (
              <FiChevronUp size={28} style={{ marginLeft: 4 }} />
            ) : (
              <FiChevronDown size={28} style={{ marginLeft: 4 }} />
            )}
          </PrimaryPinkButton>
          {!_refusedStatus ? (
            <PrimaryPinkButton
              onClick={
                sendVoucherCampaign
                  ? () => this.toggleCampaignInfo(campaign)
                  : () => this.subscribe(campaign)
              }
            >
              {sendVoucherCampaign ? 'Enviar comprovantes' : 'Inscreva-se'}
            </PrimaryPinkButton>
          ) : (
            <PrimaryPinkButton disabled={true}>Recusada</PrimaryPinkButton>
          )}
        </div>
      </div>
    );
  };

  _renderAboutItem = (about, index) => {
    return (
      <React.Fragment key={about.title}>
        <div className={Styles['about-item']}>
          <div className={Styles['about-tag']}>
            <img src={about.image} alt={about.title} />
            <span>{about.title}</span>
          </div>
          <button
            type="button"
            onClick={() => this.toggleShowAndHideAbout(index)}
            className={Styles['about-toggle-button']}
          >
            {about?.isOpened ? (
              <AiOutlineMinus color="#fe357b" size={28}></AiOutlineMinus>
            ) : (
              <AiOutlinePlus color="#fe357b" size={28}></AiOutlinePlus>
            )}
          </button>
        </div>
        {about?.isOpened && (
          <div className={Styles['about-description']}>
            <p>{about.description}</p>
          </div>
        )}
      </React.Fragment>
    );
  };

  // Paginação
  // ------------------------ ------------------------------------------------------

  renderPageButtons = () => {
    const { currentPage, totalOfPages } = this.state;

    if (totalOfPages === 1) return null;
    let buttonList = [];

    for (let i = 1; i <= totalOfPages; i++) {
      buttonList.push(i);
    }

    return (
      <div className={PaginatorStyles['paginator']}>
        <div className={PaginatorStyles['paginator-block']}>
          {this.renderPrevButton()}
          <div className={PaginatorStyles['paginator-display']}>
            {currentPage} de {totalOfPages}
          </div>
          {this.renderNextButton()}
        </div>
      </div>
    );
  };

  renderPrevButton = () => {
    const { currentPage } = this.state;

    if (currentPage == 1) {
      return (
        <button className={PaginatorStyles['paginator-button']} disabled>
          &#60;
        </button>
      );
    }

    return (
      <button
        className={PaginatorStyles['paginator-button']}
        onClick={this.renderPreviousPage}
      >
        &#60;
      </button>
    );
  };

  renderNextButton = () => {
    const { currentPage, totalOfPages } = this.state;

    if (currentPage == totalOfPages) {
      return (
        <button className={PaginatorStyles['paginator-button']} disabled>
          {' '}
          &#62;
        </button>
      );
    }

    return (
      <button
        className={PaginatorStyles['paginator-button']}
        onClick={this.renderNextPage}
      >
        &#62;
      </button>
    );
  };

  renderNextPage = () => {
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      () => this.getMyCampaigns()
    );
  };

  renderPreviousPage = () => {
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      () => this.getMyCampaigns()
    );
  };

  // ------------------------ ------------------------------------------------------

  render() {
    const filterOptions = [
      { name: 'Aberto', status: 1 },
      { name: 'Em análise', status: 2 },
      { name: 'Participando', status: 3 },
      { name: 'Não foi dessa vez :(', status: 4 },
      { name: 'Concluído', status: 5 },
    ];

    const { currentCampaign } = this.state;

    return (
      <div id={Styles['glampartner-publis']}>
        <Helmet>
          <title>Portal Glampartners: Publis</title>
        </Helmet>

        <div id={Styles['section-publis']}>
          <div className={Styles['container']}>
            <h1>Publis</h1>
            <p>
              Todas nós sabemos que os publiposts são IN-DIS-PEN-SÁ-VEIS para
              construir uma carreira de influenciadora e nossa missão é te
              conectar com as melhores marcas de beleza!{' '}
              <strong>
                Confira as campanhas disponíveis e faça sua inscrição.
              </strong>
            </p>
            <span>
              <Link
                to="#"
                onClick={() => this.handleScrollIntoView(this.sectionAboutRef)}
              >
                Clique aqui
              </Link>{' '}
              e saiba mais como funciona
            </span>
          </div>
        </div>

        <div id={Styles['section-campaigns']}>
          <div className={Styles['container']}>
            <h1>Campanhas</h1>
            <div
              className={Styles['filter-content']}
              style={{ display: 'none' }}
            >
              <span>Filtrar por:</span>
              <div className={Styles['filter-group']}>
                {filterOptions.map(option => (
                  <SecondPinkButton key={option.name}>
                    {option.name}
                  </SecondPinkButton>
                ))}
              </div>
            </div>
          </div>
          <div className={Styles['cards-group']}>
            {this.state.campaigns.length > 0 &&
              this.state.campaigns.map((campaign, index) =>
                this._renderCampaignCard(campaign, index)
              )}
          </div>
          {this.renderPageButtons()}
        </div>

        <div id={Styles['section-about']} ref={this.sectionAboutRef}>
          <div className={Styles['container']}>
            <h1>Como funciona</h1>

            <div className={Styles['about-list']}>
              {this.state.aboutList.length > 0 &&
                this.state.aboutList.map((about, index) =>
                  this._renderAboutItem(about, index)
                )}
            </div>
          </div>
        </div>

        {/* Modals */}
        <Modal
          visible={this.state.campaignInfoVisible}
          onCloseModal={() => this.toggleCampaignInfo(currentCampaign)}
        >
          {this.renderCampaignInfo()}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  toggle: name => {
    dispatch(ExecuteToggle(name));
  },
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

ParticiparCampanhasMarcas = connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticiparCampanhasMarcas);
